export enum DriverAppStatus {
  allStatus = 'AllStatus',
  connectedStatus = 'Connected',
  disconnectedStatus = 'Disconnected',
  notStartedStatus = 'NotStarted'
}
